// extracted by mini-css-extract-plugin
export default {"option":"Option_option__mI8I-"};